export default {"src":"/_next/static/image/public/images/ic_info_white.c513382394308952beaba760b31d553c.svg","height":20,"width":20};